import { Box } from '@material-ui/core';
import { ReportWorkSiteMonthlyEnqueteDataForm } from '../../../types/report';
import { useEnqueteMonthlyPieStyles } from '../../../assets/styles/Report.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  enqueteForm: ReportWorkSiteMonthlyEnqueteDataForm;
};

/**
 *
 *
 *
 * @method Component
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const ReportMonthlyEnqueteTickC5 = (props: Props) => {
  const { enqueteForm } = props;
  const classes = useEnqueteMonthlyPieStyles();

  return (
    <Box display="flex">
      <Box className={classes.columnC5}>
        <div className={classes.answerColorBoxError} />
        <div className={classes.answerColorBoxError} />
        <div className={classes.answerColorBox} />
        <div className={classes.answerColorBox} />
        <div className={classes.answerColorBox} />
      </Box>
      <Box className={classes.columnC5Column}>
        <div>
          {enqueteForm.isReverse
            ? enqueteForm.leftComment
            : enqueteForm.rightComment}
        </div>
        <div className={classes.columnC5ColumnArrow}>
          <img src="/images/report/piearrow.svg" alt="グラフ" />
        </div>
        <div>
          {enqueteForm.isReverse
            ? enqueteForm.rightComment
            : enqueteForm.leftComment}
        </div>
      </Box>
    </Box>
  );
};

export default ReportMonthlyEnqueteTickC5;
